import { GlobalStyles } from '@soluto-private/mx-asurion-ui-react';

import './app.css';
import { WidgetDocs } from './widgetDocs';

export function App() {
  return (
    <main>
      <GlobalStyles />
      <WidgetDocs />
    </main>
  );
}

export default App;
